
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/pipedrive",
      function () {
        return require("private-next-pages/destinations/pipedrive.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/pipedrive"])
      });
    }
  